import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dev-page',
  templateUrl: './dev-page.component.html',
  styleUrls: ['./dev-page.component.css']
})
export class DevPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
